import { Box } from '@mui/material'

import { BookingAddress } from 'generated/graphql'
import { formatTimeSlot } from 'helpers'

import { LocationItem } from './LocationItem'
import { SectionHeader } from './SectionHeader'

interface PickupSectionProps {
  bookingCurrentAction?: BookingAddress | null
}

const containerStyles = {
  mb: 4,
  borderBottom: '2px solid #F6F4F4',
  pb: 2,
}

export const PickupSection = ({ bookingCurrentAction }: PickupSectionProps) => {
  if (!bookingCurrentAction) {
    return null
  }

  const address = bookingCurrentAction.address

  const locationName = address?.city

  const fullAddress = [
    address?.addressLine1,
    address?.addressLine2,
    address?.city,
    address?.postcode,
  ]
    .filter(Boolean)
    .join(', ')

  const timeSlot = formatTimeSlot(bookingCurrentAction.at, bookingCurrentAction.by)

  return (
    <Box sx={containerStyles}>
      <SectionHeader title='PICK-UP' />
      <Box>
        <LocationItem name={locationName} address={fullAddress} timeSlot={timeSlot} />
      </Box>
    </Box>
  )
}
